export default {"src":"/_next/static/media/FAQ.e418282d.svg","height":202,"width":384,"blurWidth":0,"blurHeight":0};